export const GET_SEARCH_RESULT = 'GET_SEARCH_RESULT'
